import React from 'react'
import { Grid, Table, Row, Col, Panel, FormGroup, Checkbox, Button, Radio, Image } from 'react-bootstrap';

import Message from '../../lib/Message'

import DateHelpers from '../../lib/DateHelpers'

import { disintermediation } from '../../lib/Disintermediation'
import Conversation from '../../lib/Conversation'


import { EditModal, NotificationModal } from '../../components/Modals'


class Disintermediation extends React.Component {
    state = {
        loading: true,
        conversations: [],
        show_popup: false
    }

    getConversations = async() => {
        const conversationList = await disintermediation(10, 0);
        this.setState({
            loading: false,
            conversations: conversationList.conversations.map((conversation) => new Conversation(conversation))
        })
        console.log(conversationList);
    }

    componentDidMount() {
        this.getConversations()
    }

    render() {
        return (
            <div>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Most recent activity</th>
                            <th>Most recent message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.conversations.map((conversation, index)=>{
                                if ( conversation.participants[0].swipecast_user_id!= "2a0051934621c66300519d47b9df5adb20d2ea556370" && conversation.participants[1].swipecast_user_id!= "2a0051934621c66300519d47b9df5adb20d2ea556370")
                                {
                                    const name1 = conversation.participants[0].first_name + ' ' + conversation.participants[0].last_name ;
                                    const name2 = conversation.participants[1].first_name + ' ' + conversation.participants[1].last_name ;
                                    return (
                                        <tr onClick = {()=>{this.setState({show_popup: true, conversationId: conversation.id})}}>
                                            <td>{name1}</td>
                                            <td>{name2}</td>
                                            <td>{DateHelpers.timeStampToLabel(conversation.last_activity, true)}</td>
                                            <td>
                                                {
                                                conversation.messages.reverse().map(message => (
                                                    message.swipecast_user_id == conversation.participants[0].swipecast_user_id ?
                                                    <div style={{backgroundColor:'#ccc'}}>{`${name1}: ${message.message}`}</div>
                                                    :
                                                    <div>{`${name2}: ${message.message}`}</div>
                                                ))
                                            }
                                            </td>
                                            {!conversation.messages[0]  && <td>No Messages Yet</td>}
                                        </tr>

                                    )
                                }
                            })
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default Disintermediation;
